import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EventEmitter } from "events";
import { NgxSpinnerService } from "ngx-spinner";
import { DialogData } from "src/app/entities/dialogData";
import { ForecastService } from "src/app/services/forecast.service";
import { SharedService } from "src/app/services/sharedService";

@Component({
  selector: "app-submit-comment-dialog",
  templateUrl: "./submit-comment-dialog.component.html",
  styleUrls: ["./submit-comment-dialog.component.css"],
})
export class SubmitCommentDialogComponent implements OnInit {
  text: string;
  emitter: EventEmitter;
  obj: any;
  action: any;
  processes = [];
  forecastState;
  constructor(
    public dialogRef: MatDialogRef<SubmitCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public sharedService: SharedService,
    private forecastService: ForecastService,
    private spinner: NgxSpinnerService
  ) {
    this.text = data["text"];
    this.obj = data["obj"];
    this.action = data["action"];
  }
  maxLines = 3;

  enforceMaxLines(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    const lines = textarea.value.split("\n");

    if (lines.length > this.maxLines) {
      textarea.value = lines.slice(0, this.maxLines).join("\n");
    }
  }
  async ngOnInit() {
    if (this.obj.type === "forecast")
      this.forecastState = await this.forecastService
        .getForecastState(this.obj.year, this.obj.municipality)
        .toPromise();
    else
      this.forecastState = await this.forecastService
        .getForecastPerformanceState(
          this.obj.year,
          this.obj.month,
          this.obj.municipality
        )
        .toPromise();
    if (!this.forecastState) this.forecastState = {};
    else {
      let dialogDoc = {
        comment: this.forecastState.comment,
        year: this.obj.year,
      };
      if (this.obj.type === "performance") dialogDoc["month"] = this.obj.month;
      this.sharedService.confirmDialogAction(dialogDoc);
      this.dialogRef.close(true);
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
  onConfirmClick(): void {
    let dialogDoc = {
      comment: this.forecastState.comment,
      year: this.obj.year,
    };
    if (this.obj.type === "performance") dialogDoc["month"] = this.obj.month;
    this.sharedService.confirmDialogAction(dialogDoc);
    this.dialogRef.close(true);
  }
}
